import React, { PureComponent } from "react";
import clsx from "clsx";
import { Tooltip as ReactTooltip } from "react-tooltip";
import DatePicker from "./DatePicker/DatePicker";

import Heading from "./Elements/Heading";
import CSVExport from "./CSVExport/CSVExport.js";

class WidgetHeader extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      selectedItem: ["Last7"],

      group_slug: props.group_slug,
      region_slug: props.group_slug,
      show_table_filters: false,
    };
  }

  getElementFromChild = (childRef) => {
    this.setState({
      childTableRef: childRef,
    });
  };

  handleToggleFilters = (e) => {
    let widget = e.target.closest(".widget");
    let table = widget.querySelector(".react-bootstrap-table");
    let filters = table.getElementsByClassName("custom-table-filter-input");

    for (let i = 0; i < filters.length; ++i) {
      let filter = filters[i];
      let label = filter.previousElementSibling.innerText;

      filter.placeholder = label || "Enter value";
      filter.classList.toggle("d-block");
    }

    this.setState((prevState) => ({
      show_table_filters: !prevState.show_table_filters,
    }));
  };

  renderTitle = (title, table_filter, tooltip) => {
    let style = clsx("table-filter-toggle", {
      "table-filter-toggle--on": this.state.show_table_filters,
    });

    if (title) {
      return (
        <h5 className="widget__title noselect">
          {title}&nbsp;
          {tooltip && (
            <>
              <span
                className="with-tooltip"
                data-tooltip-id={`tooltip-${title}`}
                data-tooltip-html={tooltip}
                data-tooltip-delay-hide="0"
              />
              <ReactTooltip
                id={`tooltip-${title}`}
                className="title-tooltip-header"
                clickable={true}
                delayHide={0}
              />
            </>
          )}
          {table_filter && (
            <button
              className={style}
              onClick={(e) => this.handleToggleFilters(e)}
              title="Display Filters"
            >
              {" "}
              <i className="fas fa-filter" />{" "}
            </button>
          )}
        </h5>
      );
    } else return <h5 className="widget__title noselect">&nbsp;</h5>;
  };

  itemToString = (i) => (i ? i.name : "");

  widgetHeaderGlobalDateChange = (start, end) => {
    this.props.widgetContainerGlobalDateChange(start, end);
  };

  render() {
    const {
      URL,
      TITLE,
      DESCRIPTION,
      PAGE_TITLE,
      SUBTITLE,
      TOOLTIP,
      HAS_DATEPICKER,
      DATE_RANGES,
      SELECTED_DATE,
      CSV_EXPORT,
      TABLE_FILTER,
      START_DATE,
      END_DATE,
      handleCustomDateRangeChange,
    } = this.props;

    return (
      <>
        <header className="row">
          <div className="col-auto">
            {this.renderTitle(TITLE, TABLE_FILTER, TOOLTIP)}
            {SUBTITLE && (
              <Heading size={6} className={"mb-1"}>
                {SUBTITLE}
              </Heading>
            )}

            {PAGE_TITLE && <h5 className="page__title">{PAGE_TITLE}</h5>}
          </div>
          <div className="col d-flex justify-content-end">
            {HAS_DATEPICKER && (
              <DatePicker
                key={Math.random()}
                onChange={handleCustomDateRangeChange}
                selectedDate={SELECTED_DATE}
                dateRanges={DATE_RANGES}
                startDate={START_DATE}
                endDate={END_DATE}
                url={URL}
                widgetHeaderGlobalDateChange={this.widgetHeaderGlobalDateChange}
              />
            )}

            {CSV_EXPORT && (
              <CSVExport
                {...this.props}
                childRef={() => this.props.component()}
              />
            )}
          </div>
        </header>

        {DESCRIPTION && <h6 className="page__title">{DESCRIPTION}</h6>}
      </>
    );
  }
}

export default WidgetHeader;
